import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

export default function Feed() {
  const { '*': url } = useParams();
  const [newsList, setNewsList] = useState([]); // Store all loaded news
  const [offset, setOffset] = useState(0);
  const [end, setEnd] = useState(false);
  const loadingRef = useRef(false);

  // Fetch and append news at current offset
  const fetchData = (currentOffset) => {
    if (!url || end || loadingRef.current) return;
    loadingRef.current = true;
    fetch(`http://newsoshort.amantest.serv00.net/api/news?feed_url=${encodeURIComponent(url)}&offset=${currentOffset}&limit=1`)
      .then(res => res.json())
      .then(json => {
        if (!json || (Array.isArray(json) && json.length === 0)) {
          setEnd(true);
        } else {
          setNewsList(prev => [...prev, json && Array.isArray(json) ? json[0] : json]);
        }
      })
      .catch(() => setEnd(true))
      .finally(() => { loadingRef.current = false; });
  };

  // Load new news every second, append only new ones
  useEffect(() => {
    if (end) return;
    const interval = setInterval(() => {
      fetchData(offset + newsList.length);
    }, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [url, end, newsList.length]);

  // Scroll to bottom on new news
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [newsList.length]);

  // Manual next/prev navigation (scroll to news)
  const handleNext = () => {
    if (newsList.length > offset + 1) setOffset(prev => prev + 1);
  };
  const handlePrev = () => setOffset(prev => (prev > 0 ? prev - 1 : 0));

  if (newsList.length === 0 && end) {
    return (
      <div className="end-message" style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', color: 'white'
      }}>
        <h2>No articles found</h2>
        <a href="/" className="change-genre-btn" style={{
          display: 'inline-flex', alignItems: 'center', backgroundColor: '#4a6cf7', color: 'white',
          padding: '0.8rem 1.8rem', borderRadius: '50px', textDecoration: 'none', fontWeight: 500
        }}>
          <i className="fas fa-sync-alt" style={{ marginRight: 8 }}></i> Change Genre
        </a>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="news-container"
      style={{
        minHeight: '100vh',
        height: '100vh',
        overflowY: 'auto',
        width: '100%',
        background: '#000',
        position: 'relative',
        scrollBehavior: 'smooth'
      }}
    >
      {newsList.map((data, idx) => (
        <div
          key={idx}
          className="news-item"
          style={{
            minHeight: '100vh',
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            display: idx === offset ? 'flex' : 'none', // Only show current news
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <div
            className="news-blurred-background"
            style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url('${data.image_url || "https://images.unsplash.com/photo-1557683316-973673baf926?auto=format&fit=crop&q=80"}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'blur(10px)',
              transform: 'scale(1.1)',
              zIndex: 0,
              willChange: 'transform',
              animation: 'gentle-pulse 8s infinite alternate'
            }}
          ></div>
          <div className="news-overlay" style={{
            position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1
          }}></div>
          <div className="news-content" style={{
            position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center'
          }}>
            <p className="news-summary" style={{
              color: '#fff', fontSize: '1.6rem', lineHeight: 1.6, maxWidth: 800, margin: '0 auto 2rem', fontWeight: 300,
              opacity: 1, transform: 'translateY(0)', textShadow: '0 2px 5px rgba(0,0,0,0.5)'
            }}>
              {data.summary}
            </p>
          </div>
        </div>
      ))}
      {end && (
        <div style={{ color: 'white', textAlign: 'center', padding: '2rem' }}>
          <h3>You've reached the end</h3>
        </div>
      )}
      <div style={{
        position: 'fixed', bottom: 30, right: 30, zIndex: 4, display: 'flex', gap: '1rem'
      }}>
        <button onClick={handlePrev} disabled={offset === 0} style={{
          padding: '0.7rem 1.5rem', borderRadius: '50px', background: '#4a6cf7', color: 'white', border: 'none', fontWeight: 500, cursor: offset === 0 ? 'not-allowed' : 'pointer'
        }}>
          Previous
        </button>
        <button onClick={handleNext} disabled={offset >= newsList.length - 1 || end} style={{
          padding: '0.7rem 1.5rem', borderRadius: '50px', background: '#4a6cf7', color: 'white', border: 'none', fontWeight: 500, cursor: end ? 'not-allowed' : 'pointer'
        }}>
          Next
        </button>
      </div>
    </div>
  );
}
